import React from 'react';
import { useSelector } from 'react-redux';
import {
    InvoiceDetailsContainer,
    InvoiceOrderDetails,
    InvoiceDataContainer,
    OrderNoTypeContainer,
    OrderTypeFontStlye,
    InvoiceOrderPOFontStyle,
    InvoiceStatusPrice,
    OrderTypeSpanContianer,
    InvoiceOrderNoPriceContainer,
    InvoicedContainer,
} from './OrderSummaryDescription.styled';
import ReplenishIcon from 'src/assets/images/ReplenishIcon.svg';
import TissueIcon from 'src/assets/images/TissueItemIcon.svg';
import NonTissueIcon from 'src/assets/images/NonTissueItemIcon.svg';
import { isMobileDevice, setCurrencyFormat } from 'src/utils/util';
import { OrderTypes } from 'src/constants/orderListConstants';
import { useTranslation } from 'react-i18next';

const OrderSummaryDescription = (props) => {
    const ISOCountryCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const { orderArray } = props;
    const orderArrayLength = orderArray.length - 1;
    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const currencyISOCode = useSelector(
        (state) =>
            state.orderSummaryReducer.billingSummary?.cartSummary
                ?.currencyISOCode
    );
    const { currentOrderType } = orderBasicDetails || {};
    const { t } = useTranslation();
    return (
        <React.Fragment>
            {orderArray?.map((order, index) => (
                <InvoicedContainer
                    isReplenish={order.orderType === OrderTypes().REPLENISHMENT || order.orderType === OrderTypes().MAST_REPLENISHMENT}
                    key={order.sapOrderId}
                    borderTopRightRadius={index === 0 && '6px'}
                    borderTopLeftRadius={index === 0 && '6px'}
                    borderBottomRightRadius={
                        index === orderArrayLength && '6px'
                    }
                    borderBottomLeftRadius={index === orderArrayLength && '6px'}
                >
                    <InvoiceDetailsContainer
                        // setbackground={
                        //     order?.orderType === 'Non Tissue' ||
                        //     order?.orderType === 'Tissue Services'
                        // }
                        key={order.sapOrderId}
                        borderTopRightRadius={index === 0 && '10px'}
                        borderTopLeftRadius={index === 0 && '10px'}
                        borderBottomRightRadius={
                            index === orderArrayLength && '10px'
                        }
                        borderBottomLeftRadius={
                            index === orderArrayLength && '10px'
                        }
                        borderRadius={isMobileDevice() ? '0px' : '7px'}
                    >
                        <InvoiceOrderDetails>
                            <InvoiceDataContainer isOrderType>
                                <div>
                                    {order?.orderType ? (
                                        ISOCountryCode !== 'US' ? (
                                            currentOrderType == 'ZOR' ? (
                                                <OrderTypeFontStlye>
                                                    {OrderTypes().EQUITY_ORDER}
                                                </OrderTypeFontStlye>
                                            ) : (
                                                <OrderTypeFontStlye>
                                                    {order.orderType}
                                                </OrderTypeFontStlye>
                                            )
                                        ) : (
                                            ISOCountryCode == 'US' && (
                                                <OrderTypeFontStlye>
                                                    {currentOrderType !==
                                                        'ZKA' &&
                                                        order.orderType}
                                                    {currentOrderType ==
                                                        'ZKA' &&
                                                        t(
                                                            'createOrderMethods.createConsignmentReturn'
                                                        )}
                                                </OrderTypeFontStlye>
                                            )
                                        )
                                    ) : null}
                                </div>
                                {order?.poNumber &&
                                    currentOrderType !== 'ZLC' &&
                                    currentOrderType !== 'ZKA' && (
                                        <InvoiceOrderPOFontStyle isPoNumber>
                                            {t('common.poNumber') +
                                                ' ' +
                                                order.poNumber}
                                        </InvoiceOrderPOFontStyle>
                                    )}
                                {order?.poNumber &&
                                    currentOrderType == 'ZKA' && (
                                        <InvoiceOrderPOFontStyle isPoNumber>
                                            {t('common.poNumber') +
                                                ' ' +
                                                order.poNumber.replace(
                                                    'Cons Return -',
                                                    ''
                                                )}
                                        </InvoiceOrderPOFontStyle>
                                    )}
                            </InvoiceDataContainer>
                            <InvoiceDataContainer isOrderStatus>
                                {order?.shippingStatus && (
                                    <InvoiceStatusPrice
                                        style={{
                                            marginTop: '2px',
                                            textAlign: 'right',
                                        }}
                                        isInvoiceStatus
                                    >
                                        {order.shippingStatus}
                                    </InvoiceStatusPrice>
                                )}
                            </InvoiceDataContainer>
                        </InvoiceOrderDetails>
                        <InvoiceOrderNoPriceContainer
                            IsConsignmentReturn={currentOrderType == 'ZKA'}
                        >
                            <InvoiceDataContainer isOrderNo>
                                {order?.salesOrg && order?.sapOrderId && (
                                    <OrderNoTypeContainer
                                        IsConsignmentReturn={
                                            currentOrderType == 'ZKA'
                                        }
                                    >
                                        <OrderTypeSpanContianer
                                            sourcePath={
                                                order.orderType ===
                                                OrderTypes().REPLENISHMENT ||
                                                order.orderType ===
                                                    OrderTypes().MAST_REPLENISHMENT
                                                    ? ReplenishIcon
                                                    : order.salesOrg === 'S030'
                                                    ? TissueIcon
                                                    : order.salesOrg ===
                                                          'S002' &&
                                                      NonTissueIcon
                                            }
                                            display={
                                                order.orderType ===
                                                    OrderTypes()
                                                        .REPLENISHMENT ||
                                                order.salesOrg === 'S030' ||
                                                order.salesOrg === 'S002'
                                                    ? 'block'
                                                    : 'none'
                                            }
                                        ></OrderTypeSpanContianer>
                                        <InvoiceOrderPOFontStyle isOrderNo>
                                            {t(
                                                'orders.shipTrackLabels.sapOrderId'
                                            ) +
                                                ' ' +
                                                order.sapOrderId}
                                        </InvoiceOrderPOFontStyle>
                                    </OrderNoTypeContainer>
                                )}
                            </InvoiceDataContainer>
                            {currentOrderType !== 'ZKA' &&
                                currentOrderType !== 'ZLC' && (
                                    <InvoiceDataContainer isOrderPrice>
                                        {order?.price !== undefined &&
                                            order?.price !== '' && (
                                                <InvoiceStatusPrice isPrice>
                                                    {setCurrencyFormat(
                                                        order.price,
                                                        true,
                                                        {
                                                            currency:
                                                                currencyISOCode,
                                                        }
                                                    )}
                                                </InvoiceStatusPrice>
                                            )}
                                    </InvoiceDataContainer>
                                )}
                        </InvoiceOrderNoPriceContainer>
                    </InvoiceDetailsContainer>
                </InvoicedContainer>
            ))}
        </React.Fragment>
    );
};

export default OrderSummaryDescription;
